import React, { memo, useState, useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { getSpecifications } from "services/headwallServices";
import { CloseIcon } from "assets/images";
import { pixelPerInch, PRODUCT } from "constants/appConstant";
import useLoaderStore from "store/loaderStore";
import Select from "../select";
import { Input } from "components";

function SpecificationModal({
  view_only,
  product,
  model,
  service: ser,
  handleClose,
  handleDragStart,
}) {
  const { setLoading } = useLoaderStore();
  const [service, setService] = useState();
  const [specsData, setSpecsData] = useState("");
  // const [manufacturers, setManufacturers] = useState([]);
  const [specifications, setSpecifications] = useState([]);

  useEffect(() => {
    setService(ser);
  }, [ser]);

  //  Queries
  const { isLoading } = useQuery({
    queryKey: ["specifications", service?._id],
    queryFn: () =>
      getSpecifications(
        service?._id,
        service?.category_id,
        product,
        service?.manufacturer_id
      ),
    onSuccess: (data) => {
      const res = data.data.data;
      setSpecsData(res);
    },
    enabled: !!service,
    retry: false,
  });

  //manage loader
  useMemo(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  useEffect(() => {
    const specObj = specsData?.specification?.find(
      (sp) => sp?.service_item_id === service?.specification?.service_item_id
    );
    const specs = specsData?.specification?.filter(
      (sp) => sp.manufacturer_id === specObj?.manufacturer_id
    );
    const specifications = specs?.map((sp) => {
      return { label: sp.name, value: sp.service_item_id };
    });
    if (specifications?.length) setSpecifications(specifications);
  }, [
    specsData?.manufacturer,
    specsData?.specification,
    service?.specification,
    ser,
  ]);

  const serviceWidth = () => {
    if (
      model === PRODUCT.INFINITY ||
      model === PRODUCT.COMPASS ||
      model === PRODUCT.ARRAY
    )
      return service?.gang_width / pixelPerInch;
    else if (model === PRODUCT.AXIOM) {
      if (service?.category === "Medical Gas Outlet")
        return (service?.width + 2.375) / pixelPerInch; //2.375 for side margins
      else return (service?.width + 0.125) / pixelPerInch;
    } //2.23 adding to add service width
  };

  const servicePadding = () => {
    if (model === PRODUCT.INFINITY) return 0;
    else if (model === PRODUCT.AXIOM) {
      if (!ser.is_slide) return `13.39px 0 13.39px 0`;
      else return `5px 0 5px 0`;
    }
  };

  const handleProduct = (e) => {
    const { value } = e.target;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const updatedSpecification = {
      ...service.specification,
      specification: selectedLabel,
      service_item_id: value,
    };

    // Use the spread operator to create a new state object with the updated nested object
    setService((prevState) => ({
      ...prevState,
      specification: updatedSpecification,
    }));
  };

  const handleComment = (e) => {
    const { value } = e.target;
    const updatedSpecification = {
      ...service.specification,
      custom_specification: value,
    };

    // Use the spread operator to create a new state object with the updated nested object
    setService((prevState) => ({
      ...prevState,
      specification: updatedSpecification,
    }));
  };

  const handleServiceDrag = (e) => {
    const newService = { ...service };
    delete newService?.u_id;
    handleDragStart(newService, e);
  };

  return (
    <div
      className="relative z-10 ease-out duration-300 "
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="inset-0 z-10 ease-out duration-300">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="relative transform  rounded-lg bg-white text-left shadow-xl transition-all sm:w-full sm:max-w-lg">
            <div className="bg-white px-3 pb-4 pt-3 sm:pb-4">
              <div className="flex w-100 justify-end">
                <img
                  src={CloseIcon}
                  alt=""
                  className="cursor-pointer closeBtnModal"
                  onClick={handleClose}
                />
              </div>
              <div className="specification-popup sm:p-6">
                <div className="flex items-center gap-2">
                  <div className="flex-1 flex justify-center">
                    <div
                      draggable
                      onDragStart={(e) => handleServiceDrag(e)}
                      className="flex justify-center hover:z-50 "
                      style={{
                        width: serviceWidth(),
                        padding: servicePadding(),
                        // height: ser.height / 0.056,
                        cursor: "grab",
                      }}
                    >
                      <img
                        draggable={false}
                        src={service?.image_url}
                        alt="..."
                        style={{
                          height: ser.height / pixelPerInch,
                          objectFit: "contain",
                          width: "auto",
                          pointerEvents: "none",
                        }}
                      />
                    </div>
                  </div>
                  <div className="font-bold lg:text-sm xl:text-base flex-1 text-center">
                    {service?.name}
                  </div>
                </div>
                <hr className="my-5" />

                <div className="mt-6">
                  <div className="mb-2 text-md font-normal">Manufacturer</div>
                  <Input
                    name="manufacturer"
                    className="bg-white font-bold w-full border border-teal-700 rounded p-2 opacity-50 text-sm"
                    value={service?.specification?.manufacturer}
                    readonly={true}
                  />
                  <>
                    <div className=" mt-5 mb-2 text-md font-normal">
                      Product
                    </div>
                    {view_only ||
                    service?.specification?.custom_specification ? (
                      <Input
                        name="specification"
                        className="bg-white  font-bold w-full border border-teal-700 rounded p-2 opacity-50 text-sm"
                        value={
                          !service?.specification?.custom_specification
                            ? service?.specification?.specification
                            : ""
                        }
                        readonly={true}
                      />
                    ) : (
                      <Select
                        name="product"
                        className={`bg-white font-bold w-full border border-teal-700 rounded p-2 ${
                          service?.specification?.custom_specification
                            ? "opacity-50"
                            : ""
                        }`}
                        options={specifications}
                        value={
                          !service?.specification?.custom_specification
                            ? service?.specification?.service_item_id
                            : ""
                        }
                        handleSelect={handleProduct}
                        isDisabled={
                          service?.specification?.custom_specification
                            ? true
                            : false
                        }
                      />
                    )}
                  </>
                </div>
                <div className="my-6 flex">Custom Specifications Text</div>
                <div className="flex items-end">
                  <textarea
                    name="custom_specification"
                    rows="5"
                    className={`bg-white w-full p-2 rounded font-bold text-xs border border-slate-300 ${view_only?"opacity-50":""}`}
                    placeholder="Type Specification here..."
                    value={service?.specification?.custom_specification || ""}
                    onChange={handleComment}
                    disabled={view_only ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(SpecificationModal);
